import EllosAction from '../../../core/interfaces/ellosAction.interface';
import { ActionTypes } from '../../../core/models/actionTypes';
import { Category } from '../models/category';

export function categoriesReducer(state: Category, action: EllosAction) {
  switch (action.type) {
    case ActionTypes.Categories: {
      state = action.payload;
      return state;
    }

    default:
      return state;
  }
}
